import { useAuthentication } from '@cascade/react/authentication';
import { useProjects } from '@cascade/react/projects';
import { setIdentity } from '@cascade/react-dom/observability';
import { useEffect } from 'react';
import type { PropsWithChildren } from 'react';
import { toIdentity } from './ObservabilityIdentity.helpers.ts';

export const ObservabilityIdentityProvider = ({
  children,
}: PropsWithChildren) => {
  const { user } = useAuthentication();
  const { currentProjectId } = useProjects();

  useEffect(() => {
    const identity = toIdentity(user, currentProjectId);

    setIdentity(identity);
  }, [user, currentProjectId]);

  return children;
};
